import { render, staticRenderFns } from "./ModalSendScenario.vue?vue&type=template&id=2aa208a7&"
import script from "./ModalSendScenario.vue?vue&type=script&lang=js&"
export * from "./ModalSendScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports